import Repository from "../../services/Repository"


const reSource = '/PregnancyCalendars';


export default {
    getMotherUser(data) {
        return Repository.post(`${reSource}/pregnancy/all-filterd`, data);
    },
    getBabyUser(data) {
        return Repository.post(`${reSource}/baby/all-filtered`, data);
    },
    getBabyInfo(data, id) {
        return Repository.get(`${reSource}/baby/profile/panel/` + id + data);
    },
}
